module.exports = __webpack_public_path__ + "static/media/black-woman-5505581_960_720.fef0882d.jpg";